import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/navbar/Header";
import Footer from "../components/footer/Footer";
import awardSvg1 from "../assets/awards/1.svg";
import awardSvg2 from "../assets/awards/2.svg";
import awardSvg3 from "../assets/awards/3.svg";
import awardSvg4 from "../assets/awards/4.svg";
import awardSvg5 from "../assets/awards/5.svg";
import awardSvg6 from "../assets/awards/6.svg";

import awardSvg8 from "../assets/awards/8.svg";
import awardSvg9 from "../assets/awards/9.svg";
import awardSvg10 from "../assets/awards/10.svg";
import awardSvg11 from "../assets/awards/11.svg";
import awardSvg12 from "../assets/awards/12.svg";
import awardSvg13 from "../assets/awards/13.svg";
import awardSvg14 from "../assets/awards/14.svg";
import serviceBanner from "../assets/mobile-banners/Gem_Web_Banners_Gallary.webp";
import CustomSlider from "../components/CustomSlider";
const servicemobileSlides = [
  {
    img: serviceBanner,
    alt: "Offer 1",
  },

];
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Gallery() {
  const awards = [
    {
      name: "Dealer within a region with maximum sales to service ratio",
      pic: awardSvg1,
    },
    { name: "Highest number of MSD activations", pic: awardSvg2 },
    {
      name: "Dealer within a region of maximum Sales Service ration (Annual Retails Category 7500 Vehicles)",
      pic: awardSvg3,
    },
    {
      name: "Overall Performance in Service Workshop with Service Load between 500 and 1000",
      pic: awardSvg4,
    },
    { name: "Highest MI Penetration", pic: awardSvg5 },
    { name: "Highest AGS Sales -2", pic: awardSvg6 },
    { name: "Highest Paid Corporate Training", pic: awardSvg8 },
    { name: "Highest Workshop Conversion Ratio", pic: awardSvg9 },
    { name: "Outstanding Sales Performance Q2", pic: awardSvg10 },
    { name: "Best ISL initative-RO city", pic: awardSvg11 },
    { name: "HIGHEST CORPORATE PENETRATION", pic: awardSvg12 },
    { name: "Best Performance in Fleet-RO City", pic: awardSvg13 },
    { name: "Highest Retail Growth Non RO City", pic: awardSvg14 },

    // If you want JPEG also add like this:
    // { name: "Award 1 (JPEG)", pic: require("../assets/awards/1.jpeg") },
  ];

  const outlets = [
    {
      name: "Chevella",
      pic: require("../assets/outlets/chevella.jpeg"),
    },
    {
      name: "Hydernagar",
      pic: require("../assets/outlets/hydernagar.jpeg"),
    },
    {
      name: "Kondapur",
      pic: require("../assets/outlets/kondapur.jpeg"),
    },
    {
      name: "Madhapur",
      pic: require("../assets/outlets/madhapur.jpeg"),
    },
    {
      name: "Manikonda",
      pic: require("../assets/outlets/manikonda.jpeg"),
    },
    {
      name: "Moinabad",
      pic: require("../assets/outlets/moinabad.jpeg"),
    },
    {
      name: "Shabad",
      pic: require("../assets/outlets/shabad.jpeg"),
    },
    {
      name: "Vikarabad",
      pic: require("../assets/outlets/vikarabad.jpeg"),
    },
  ];

  const bikeOutlets = [
    {
      name: "Erragadda",
      pic: require("../assets/outlets/bike/erragada.jpeg"),
    },
    {
      name: "Kondapur",
      pic: require("../assets/outlets/bike/kondapur.jpeg"),
    },
    {
      name: "Krishnanagar",
      pic: require("../assets/outlets/bike/krishnanagar.jpeg"),
    },
    {
      name: "Madinaguda",
      pic: require("../assets/outlets/bike/madinaguda.jpeg"),
    },
    {
      name: "Somajiguda",
      pic: require("../assets/outlets/bike/somajiguda.jpeg"),
    },
  ];

  const [channel, setChannel] = useState(0);

  const channels = ["Awards", "Outlets", "Bike Outlets"];

  return (
    <>
      <Header />
      <div className="hidden md:block">
        <img
          src={require("../assets/banners-2/Web-Banners-Gallary.webp")}
          className="w-full 
              h-[250px]
              sm:h-[320px]
              md:h-[550px]
              lg:h-[550px]
              xl:h-[550px]
              object-cover  object-center"
          alt="outlets"
        />
      </div>
      <CustomSlider
        slides={servicemobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />
      <div className="px-4 shadow sm:px-0">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Gallery
        </p>
      </div>
      <div className="container px-5 py-16 mx-auto">
        <div className="my-8">
          <div className="flex items-center justify-center gap-5 border-gray-200/80">
            {channels.map((item, index) => (
              <div
                className={classNames(
                  channel === index &&
                  "bg-transparent border-b-2 border-red-600",
                  "font-medium cursor-pointer p-2",
                )}
                onClick={() => setChannel(index)}
                key={index}
              >
                {item}
              </div>
            ))}
          </div>
        </div>

        {channel === 0 && (
          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {awards.map((item, index) => (
              <div
                key={index}
                className="overflow-hidden transition duration-300 bg-white border border-gray-200 shadow-sm group rounded-xl hover:shadow-lg"
              >
                {/* Image Box */}
                <div className="h-[260px] w-full bg-gray-50 flex items-center justify-center overflow-hidden">
                  <img
                    src={item.pic}
                    alt={item.name}
                    loading="lazy"
                    className="object-contain w-full h-full p-4 transition duration-300 group-hover:scale-105"
                  />
                </div>

                {/* Title */}
                <div className="p-4 border-t border-gray-100">
                  <p className="text-sm font-semibold text-center text-gray-800 md:text-base">
                    {item.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        {channel === 1 && (
          <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {outlets.map((item) => (
              <div>
                <img
                  src={item?.pic}
                  key={item?.name}
                  loading="lazy"
                  alt={`1${item.pic}`}
                  className=" h-[300px] w-full object-cover rounded"
                />
                <p className="font-semibold text-center">{item.name}</p>
              </div>
            ))}
          </div>
        )}

        {channel === 2 && (
          <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {bikeOutlets.map((item) => (
              <div>
                <img
                  src={item?.pic}
                  key={item?.name}
                  alt={`1${item.pic}`}
                  loading="lazy"
                  className=" h-[300px] w-full object-cover rounded"
                />
                <p className="font-semibold text-center">{item.name}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Gallery;
